import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import EventEmitter from 'src/utils/EventEmitter';
import { SnackbarProvider, enqueueSnackbar } from 'notistack';
import { NativeBaseProvider, extendTheme } from 'native-base';
import { QueryClient, QueryClientProvider, QueryCache, MutationCache } from '@tanstack/react-query';
import { Auth0ProviderWithNavigate } from 'src/Auth0ProviderWIthNavigate';
import { CloseSnackbarAction } from 'src/components/CloseSnackbarAction';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query.queryKey.includes('polling')) return;
      enqueueSnackbar(`Something went wrong: ${error.message}`, {
        variant: 'error',
      });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, mutation) => {
      enqueueSnackbar(`Something went wrong: ${error.message}`, {
        variant: 'error',
      });
    }
  })
});

const theme = extendTheme({
  config: {
    initialColorMode: 'dark',
  },
  colors: {
    custom: {
      grey: {
        1: '#333333',
        2: '#DEE5EF',
        4: '#373940',
        5: '#868383',
        6: '#7F8799',
        8: '#EBEEF2',
        9: '#F4F6F9',
        10: '#FAFAFB',
        11: '#F2F2F2',
        12: '#7E8B9E',
        13: '#ebeef2',
        14: 'rgba(0, 0, 0, 0.04)',
        15: '#A09C9C',
        100: '#b5b7ba',
        101: '#797979',
      },
      gray: {
        4: '#13161C',
        5: '#414249',
        6: '#F2F2F2',
      },
      green: {
        100: '#5FB882',
      },
      red: {
        1: '#FF2C27',
        2: 'rgba(255, 44, 39, 0.1)',
      },
      black: {
        0: '#000000',
        100: '#09101D',
      },
      state: {
        success: '#50A453',
        warning: '#FFB24D',
        error: '#FF2C27',
        info: '#0E88E9',
      },
    },
  },
});

window.addEventListener('load', () => {
  document
    .querySelector(':root')
    .style.setProperty('--vh', window.innerHeight / 100 + 'px');

  document.querySelector('.outlet-content');
});
window.addEventListener('resize', () => {
  document
    .querySelector(':root')
    .style.setProperty('--vh', window.innerHeight / 100 + 'px');
});

window.addEventListener(
  'touchstart',
  (e) => {
    if (e.target.contains(document.querySelector('.swipe_addon-container'))) {
      if (document.querySelector('.swipe_addon-container')) {
        handleTouchStart(e);
      }
    }
  },
  false
);

window.addEventListener(
  'touchmove',
  (e) => {
    if (e.target.contains(document.querySelector('.swipe_addon-container'))) {
      if (document.querySelector('.swipe_addon-container')) {
        handleTouchMove(e);
      }
    }
  },
  false
);

var xDown = null;
var yDown = null;

function getTouches(evt) {
  return (
    evt.touches || // browser API
    evt.originalEvent.touches
  ); // jQuery
}

function handleTouchStart(evt) {
  const firstTouch = getTouches(evt)[0];
  xDown = firstTouch.clientX;
  yDown = firstTouch.clientY;
}

function handleTouchMove(evt) {
  if (!xDown || !yDown) {
    return;
  }

  var xUp = evt.touches[0].clientX;
  var yUp = evt.touches[0].clientY;

  var xDiff = xDown - xUp;
  var yDiff = yDown - yUp;

  if (Math.abs(xDiff) > Math.abs(yDiff)) {
    /*most significant*/
    if (xDiff > 0) {
      /* right swipe */
    } else {
      /* left swipe */
    }
  } else {
    if (yDiff > 0) {
      EventEmitter.emit('show_notification', { value: false, type: null });
      /* down swipe */
    } else {
      /* up swipe */
    }
  }
  /* reset values */
  xDown = null;
  yDown = null;
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <Auth0ProviderWithNavigate>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        autoHideDuration={2000}
        hideIconVariant
        preventDuplicate
        action={CloseSnackbarAction}
        className="snackbar-provider"
        style={{ fontFamily: 'Söhne' }}
        sx={{
          '& .SnackbarItem-variantWarning': {
            bgcolor: '#FFB24D',
          },
          '& .SnackbarItem-variantSuccess': {
            bgcolor: '#50A453',
          },
          '& .SnackbarItem-variantError': {
            bgcolor: '#FF2C27',
          },
          '& .SnackbarItem-variantInfo': {
            bgcolor: '#0E88E9',
          },
          '& .SnackbarContent-root': {
            flexWrap: 'nowrap !important',
          },
          '& .SnackbarItem-action': {
            paddingLeft: '0px',
          },
        }}
      >
        <NativeBaseProvider theme={theme}>
          {/* <ErrorBoundary> */}
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
          {/* </ErrorBoundary> */}
        </NativeBaseProvider>
      </SnackbarProvider>
    </Auth0ProviderWithNavigate>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
